import { createFileRoute } from '@tanstack/react-router';
import OneTimeSendsTab from '@/pages/workspaces/broadcasts/one-time-sends/index.page';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';
import { validateNewslettersSearch } from '@/pages/workspaces/broadcasts/url-state';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/broadcasts/one_time_sends')({
  component: withRumPageRendered(OneTimeSendsTab),
  validateSearch: validateNewslettersSearch,
});
